exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-overlay[data-v-3fbdd09b]{position:absolute;left:0;top:0;width:100%;height:100%;background-color:hsla(0,0%,100%,.8);z-index:99998}", ""]);

// exports
